import { render, staticRenderFns } from "./settingsIcon.vue?vue&type=template&id=2d04e4e7&"
import script from "./settingsIcon.vue?vue&type=script&lang=js&"
export * from "./settingsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports